import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import { UserCard, RenderIf } from "shared/components";
import { NotFound } from "shared/modules";
import logo from "shared/media/logos/notFound.png";
import Member from "shared/media/user/userIcon.png";
import "./List.scss";

const { REACT_APP_BASE_PHOTO_URL } = process.env;
const LikeList = ({ show, onHide, userList }) => {
  const { t } = useTranslation();

  return (
    <Modal
      size="lg"
      centered
      keyboard={false}
      backdrop="static"
      show={show}
      onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t("likeList")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RenderIf
          condition={userList?.length}
          renderElse={<NotFound logo={logo} description={t("notFound")} />}>
          <div className="sendList">
            <div className="sendListBody">
              {userList?.map((c) => (
                <div key={c?.id} className="sendListBodyItem d-flex">
                  <div className="sendListBodyItemLeft">
                    <UserCard
                      image={
                        c?.siteUser?.profilePhotoUrl
                          ? `${REACT_APP_BASE_PHOTO_URL}${c?.siteUser?.profilePhotoUrl}`
                          : Member
                      }
                      userName={c?.siteUser?.firstName}
                      userLastName={c?.siteUser?.lastName}
                      profession={c?.siteUser?.position}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </RenderIf>
      </Modal.Body>
    </Modal>
  );
};

export default LikeList;
